import {BAR, SALON} from "@/modules/delivery/constants/OrderOrigin";
import BaseOrderService from "@/modules/delivery/core/services/BaseOrderService";

class ContactService extends BaseOrderService{
    constructor(order, settings, categoryService) {
        super(order, settings, categoryService);
        this.className = 'ContactService';
    }

    setOrderContact({name, phone, email, observations}){
        this.order.contact = {
            name: name,
            phone: phone,
            email: email,
            observations: observations
        }
    }

    get isReady() {
        if (this.order.contact.name && (this.order.contact.phone || this.order.origin === SALON) && (this.order.contact.email || this.order.origin === BAR || this.order.origin === SALON)) {
            return true
        }
        return false
    }

    clear() {
        this.name = '';
        this.phone = '';
        this.email = '';
        this.observations = '';
    }
}

export default ContactService;
